const CartFocusManager = {
  handleKeydown(event) {
    if (event.key !== 'Tab') return;

    const drawer = document.querySelector('cart-drawer.cart-drawer');
    if (!drawer) return;

    const focusableElements = Array.from(drawer.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    )).filter(el => !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length));

    if (focusableElements.length === 0) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey) {
      if (document.activeElement === firstElement) {
        lastElement.focus();
        event.preventDefault();
      }
    } else {
      if (document.activeElement === lastElement) {
        firstElement.focus();
        event.preventDefault();
      }
    }
  },

  trap() {
    document.addEventListener('keydown', this.handleKeydown);

    setTimeout(() => {
      const drawer = document.querySelector('cart-drawer.cart-drawer');
      const firstFocusable = drawer?.querySelector('button, [tabindex="0"]');
      if (firstFocusable) firstFocusable.focus();
    }, 100);
  },

  untrap() {
    document.removeEventListener('keydown', this.handleKeydown);
  }
};

window.CartFocusManager = CartFocusManager;

function changeQtyHandler(key, eventName, currentQty, sellingPlanItem) {
  const newQty = +currentQty;

  const requestBody = {
    id: key,
    quantity: newQty
  };

  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(requestBody)
  })
    .then(response => response.json())
    .then(data => {
      if (window.rerenderCart) {
        window.rerenderCart();
      }

      if (window.getSectionHTML) {
        window.getSectionHTML();
      }

    })
    .catch(error => {
      console.error(error);
      document.body.classList.remove('is--cart-pointer-none');
    });
}

function convertToSubscriptionHandler(currentKey, quantity, sellingPlanId, variantId) {
  // Step 1: Get current cart state to capture properties of the item being converted
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(cart => {
      // Find the specific item being converted to extract its properties
      const currentItem = cart.items.find(item => item.key === currentKey);

      // Extract the specific property if it exists
      const pcosValue = currentItem?.properties?.['_pcos_product'];

      // Look for an existing item that matches the target subscription
      const existingItem = cart.items.find(item =>
        item.variant_id === +variantId &&
        item.selling_plan_allocation &&
        item.selling_plan_allocation.selling_plan.id === +sellingPlanId
      );

      // Step 2: Remove the current one-time purchase item
      return fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: currentKey,
          quantity: 0
        })
      }).then(response => {
        if (!response.ok) throw new Error('Failed to remove one-time item');
        return { existingItem, pcosValue };
      });
    })
    .then(({ existingItem, pcosValue }) => {
      // Prepare the properties object to be passed to the new item
      const properties = pcosValue ? { '_pcos_product': pcosValue } : {};

      if (existingItem) {
        // Step 3a: If subscription exists, update quantity and ensure property is preserved
        const newTotalQty = existingItem.quantity + (+quantity);

        return fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: existingItem.key,
            quantity: newTotalQty,
            properties: properties
          })
        });
      } else {
        // Step 3b: If subscription doesn't exist, add it as a new line item with the property
        return fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: +variantId,
            quantity: +quantity,
            selling_plan: +sellingPlanId,
            properties: properties
          })
        });
      }
    })
    .then(response => {
      if (!response.ok) throw new Error('Failed to update/add subscription item');
      return response.json();
    })
    .then(data => {
      document.body.classList.remove('is--cart-pointer-none');

      // Step 4: Refresh the cart UI using the universal theme function
      if (window.rerenderCart) {
        window.rerenderCart();
      }

      if (window.getSectionHTML) {
        window.getSectionHTML();
      }
    })
    .catch(error => {
      document.body.classList.remove('is--cart-pointer-none');
      console.error('Conversion Error:', error);
    });
}

function convertToOneTimeHandler(currentKey, quantity, variantId) {
  // Step 1: Fetch the cart first to grab properties before the item is deleted
  fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(cart => {
      // Find the existing subscription item to extract its properties
      const currentItem = cart.items.find(item => item.key === currentKey);
      const pcosValue = currentItem?.properties?.['_pcos_product'];

      // Step 2: Remove the current subscription item
      return fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: currentKey,
          quantity: 0
        })
      }).then(response => {
        if (!response.ok) throw new Error('Failed to remove subscription item');
        return pcosValue; // Pass the property value down the chain
      });
    })
    .then(pcosValue => {
      // Prepare the properties object
      const properties = pcosValue ? { '_pcos_product': pcosValue } : {};

      // Step 3: Add the variant back as a one-time purchase with the property
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: +variantId,
          quantity: +quantity,
          properties: properties
        })
      });
    })
    .then(response => {
      if (!response.ok) throw new Error('Failed to add one-time purchase item');
      return response.json();
    })
    .then(data => {
      // Step 4: Refresh the cart UI
      if (window.rerenderCart) {
        window.rerenderCart();
      }

      if (window.getSectionHTML) {
        window.getSectionHTML();
      }
    })
    .catch(error => {
      console.error('Conversion Error (to One-Time):', error);
    });
}

function initQuantityWatcher() {
  document.addEventListener('change', function (event) {

    if (event.target && event.target.classList.contains('quantity__input') && !window.lastClickedElement.classList.contains('quantity__button')) {
      event.preventDefault();
      event.stopPropagation();

      document.body.classList.add('is--cart-pointer-none');
      event.target.closest('quantity-input.quantity').classList.add('is--loading');

      const cartItem = event.target.closest('.cart-item');

      changeQtyHandler(
        cartItem.getAttribute('data-key'),
        null,
        cartItem.querySelector('.quantity__input').value
      );
    }
  }, true);
}

initQuantityWatcher();

document.body.addEventListener('click', (event) => {
  if (event.target.closest('[data-js-cart-drawer="cartDrawerOpen"]')) {
    event.preventDefault();
    document.querySelector('cart-drawer.cart-drawer').classList.add('active');
    document.body.classList.add('overflow');
    CartFocusManager.trap();
  }
}, true)

document.body.addEventListener('click', (event) => {
  const quantityButton = event.target.closest('.quantity__button');
  const removeButton = event.target.closest('.cart-item__remove');
  const subscribeButtonTrigger = event.target.closest('.button-subscribe-save');
  const subscribeSwitcher = event.target.closest('.subscribe__modal-switcher');
  const subscribeItem = event.target.closest('.subscribe__plan-item');
  const cartDiscountHeader = event.target.closest('.cart-discounts__header');
  const rebuyWidgetAddToCart = event.target.closest('.rebuy-button');

  if (rebuyWidgetAddToCart) {
    if (event.isTrusted) {
      const productBlock = rebuyWidgetAddToCart.closest('.rebuy-product-block');

      if (productBlock && productBlock.querySelector('.rebuy-product-options')) {
        event.preventDefault();
        event.stopPropagation();

        rebuyWidgetAddToCart.click();
      }
    }
  }

  if (event.target.closest('[data-js-cart-drawer="cartDrawerClose"]')) {
    event.preventDefault();
    document.querySelector('cart-drawer.cart-drawer').classList.remove('active');
    document.body.classList.remove('overflow');

    CartFocusManager.untrap();

    const openBtn = document.querySelector('[data-js-cart-drawer="cartDrawerOpen"]');
    if (openBtn) openBtn.focus();
  }

  if (cartDiscountHeader) {
    const cartDiscountList = document.querySelector('.cart-discounts__list');

    if (cartDiscountList) {
      const isShowing = cartDiscountList.classList.toggle('is--show');

      cartDiscountHeader.setAttribute('aria-expanded', isShowing);
    }
  }

  if (removeButton) {
    const cartItem = event.target.closest('.cart-item');
    event.preventDefault();

    removeButton.classList.add('is--loading');
    document.body.classList.add('is--cart-pointer-none');

    changeQtyHandler(
      cartItem.getAttribute('data-key'),
      null,
      0
    );
  }

  if (quantityButton) {
    const cartItem = event.target.closest('.cart-item');
    event.preventDefault();

    quantityButton.classList.add('is--loading');
    document.body.classList.add('is--cart-pointer-none');

    changeQtyHandler(
      cartItem.getAttribute('data-key'),
      quantityButton.getAttribute('name'),
      cartItem.querySelector('.quantity__input').value
    );
  }

  if (subscribeButtonTrigger) {
    event.preventDefault();
    subscribeButtonTrigger.classList.add('active');
    subscribeButtonTrigger.nextElementSibling.classList.add('active');
    subscribeButtonTrigger.nextElementSibling.querySelector('.subscribe__modal-header').classList.add('active');


    const cartDrawer = document.querySelector('cart-drawer.cart-drawer');
    let subscriptionType = null;

    if (cartDrawer) {
      subscriptionType = cartDrawer.getAttribute('data-subscription-type');
    }
    else {
      subscriptionType = document.querySelector('.c-main-cart-items').getAttribute('data-subscription-type');
    }

    const cartItem = subscribeButtonTrigger.closest('.cart-item');

    if (cartItem) {
      const subscriptionOptions = cartItem.querySelectorAll('.subscribe__plan-item');
      if (subscriptionType == 'the-lowest') {
        subscriptionOptions[0].click();
      } else {
        subscriptionOptions[subscriptionOptions.length - 1].click();
      }
    }
  }

  if (subscribeSwitcher) {
    event.preventDefault();
    event.stopPropagation();
    const subscribeModal = subscribeSwitcher.closest('.subscribe__modal');

    subscribeModal.classList.toggle('active');
    subscribeSwitcher.closest('.subscribe__modal-header').classList.toggle('active');

    if (!subscribeModal.classList.contains('active')) {
      const cartItem = event.target.closest('.cart-item');
      subscribeSwitcher.classList.add('is--loading');
      document.body.classList.add('is--cart-pointer-none');

      convertToOneTimeHandler(
        cartItem.getAttribute('data-key'),
        cartItem.querySelector('.quantity__input').value,
        subscribeSwitcher.getAttribute('data-onetime-variant-id')
      )
    }

  }

  if (subscribeItem) {
    event.preventDefault();
    event.stopPropagation();

    const cartItem = event.target.closest('.cart-item');
    const input = subscribeItem.querySelector('input');

    document.body.classList.add('is--cart-pointer-none');
    subscribeItem.classList.add('is--loading');

    convertToSubscriptionHandler(
      cartItem.getAttribute('data-key'),
      cartItem.querySelector('.quantity__input').value,
      input.value,
      input.getAttribute('data-variant-id')
    )
  }
})

// Global flag to prevent simultaneous executions (Race Condition)
let isGiftProcessing = false;

/**
 * Checks cart for gift eligibility and handles adding/removing the gift product.
 * Uses a locking mechanism to ensure only one gift is processed at a time.
 */
window.checkAndAddGiftProduct = async function checkAndAddGiftProduct() {
  const cartDrawer = document.querySelector('cart-drawer.cart-drawer');
  if (!cartDrawer) return;

  // Prevent duplicate execution if the function is already running
  if (isGiftProcessing) {
    return;
  }

  const giftVariantId = cartDrawer.getAttribute('data-gift-product');
  const giftAmountThreshold = parseFloat(cartDrawer.getAttribute('data-gift-amount'));

  if (!giftVariantId || isNaN(giftAmountThreshold)) return;

  try {
    // Lock the function
    isGiftProcessing = true;

    // 1. Fetch current cart state
    const response = await fetch(window.Shopify.routes.root + 'cart.js');
    const cart = await response.json();
    const cartTotal = cart.total_price;

    // 2. Identify if the gift is already present
    const giftItem = cart.items.find(item =>
      item.variant_id.toString() === giftVariantId.toString() &&
      item.properties && item.properties._gift_product === 'true'
    );

    const isGiftInCart = !!giftItem;

    // 3. Logic: Add gift if threshold is reached and gift is missing
    if (cartTotal >= giftAmountThreshold && !isGiftInCart) {
      const addResponse = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(giftVariantId),
            quantity: 1,
            properties: { '_gift_product': 'true' }
          }]
        })
      });

      if (addResponse.ok && window.refreshCartDrawer) {
        await window.refreshCartDrawer();
      }
    }
    // 4. Logic: Remove gift if total drops below threshold and gift exists
    else if (cartTotal < giftAmountThreshold && isGiftInCart) {
      const removeResponse = await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: giftItem.key, // Remove by unique line item key
          quantity: 0
        })
      });

      if (removeResponse.ok && window.refreshCartDrawer) {
        await window.refreshCartDrawer();
      }
    }
  } catch (error) {
    console.error('Gift Logic Error:', error);
  } finally {
    // Always unlock the function, even if an error occurred
    isGiftProcessing = false;
  }
};

/**
 * Global tracker for the last clicked element.
 */
(function () {
  window.lastClickedElement = null;

  document.addEventListener('click', (event) => {
    // We use event.target to get the exact element that was clicked
    window.lastClickedElement = event.target;
  }, true); // Use capture phase to ensure we catch the click before other listeners
})();

window.cartCurrencyRateHandler = function cartCurrencyRateHandler() {
  const cartDrawer = document.querySelector('cart-drawer.cart-drawer');
  if (cartDrawer) {
    let giftAmount = cartDrawer.getAttribute('data-gift-amount');
    if (giftAmount) {
      giftAmount *= Shopify.currency.rate;
      cartDrawer.setAttribute('data-gift-amount', giftAmount);
    }
  }
}

document.addEventListener('DOMContentLoaded', window.cartCurrencyRateHandler);

// if (document.body.classList.contains('template--cart') || window.location.pathname.includes('/cart')) {
//   window.location.pathname = '/';
// }

/**
 * Updates the Multibuy Tiers UI with directional animation.
 * If the total increases, it uses a sequential delay (domino effect).
 * If the total decreases, it updates segments instantly for better UX.
 */
window.updateMultibuyTiers = function (cart) {
  const container = document.querySelector('multibuy-tiers');
  if (!container || !cart) return;

  const layout = container.getAttribute('data-layout') || 'primary';
  const currentRate = window.Shopify?.currency?.rate || 1.0;
  const currencySymbol = container.getAttribute('data-symbol') || '$';
  const marketSymbol = window.marketCurrencySymbol || currencySymbol;

  // Track the previous total to determine animation direction
  const cartTotal = cart.total_price;
  const lastTotal = parseFloat(container.dataset.lastTotal) || 0;
  const isDecreasing = cartTotal < lastTotal;

  // Store current total for the next update
  container.dataset.lastTotal = cartTotal;

  const getConvertedVal = (attr) => {
    const baseVal = parseInt(container.getAttribute(attr)) || 0;
    return Math.round(baseVal * currentRate);
  };

  const config = {
    tiers: [],
    congrats: container.getAttribute('data-congrats-msg')
  };

  for (let i = 1; i <= 5; i++) {
    config.tiers.push({
      val: getConvertedVal(`data-base-t${i}`),
      msg: container.getAttribute(`data-t${i}-msg`)
    });
  }

  const progressBar = container.querySelector('[data-progress-bar]');
  const messageContainer = container.querySelector('[data-message-container]');
  const tierItems = container.querySelectorAll('.multibuy-tier-item');

  const activeThresholds = config.tiers.map(t => t.val).filter(v => v > 0);
  const maxVal = activeThresholds.length > 0 ? Math.max(...activeThresholds) : 0;

  container.style.display = maxVal === 0 ? 'none' : 'block';
  if (maxVal === 0) return;

  // --- Message Logic ---
  let currentMsg = config.congrats;
  let remaining = 0;
  for (const tier of config.tiers) {
    if (tier.val > 0 && cartTotal < tier.val) {
      currentMsg = tier.msg;
      remaining = tier.val - cartTotal;
      break;
    }
  }

  if (messageContainer) {
    const formattedMoney = window.Shopify?.formatMoney
      ? window.Shopify.formatMoney(remaining)
      : `${currencySymbol}${(remaining / 100).toFixed(2)}`;
    let finalMsg = currentMsg.replace('$X', formattedMoney);
    if (currencySymbol && currencySymbol !== '$') {
      finalMsg = finalMsg.replace(/\$(?![^<]*>)/g, currencySymbol);
    }
    messageContainer.innerHTML = finalMsg;
  }

  // --- Primary Layout Logic ---
  if (layout === 'primary' && progressBar && maxVal > 0) {
    progressBar.style.width = `${Math.min((cartTotal / maxVal) * 100, 100)}%`;
  }

  // --- Secondary Layout Logic (With Directional Animation) ---
  tierItems.forEach((item, index) => {
    const tierIdx = parseInt(item.getAttribute('data-tier'));
    const threshold = config.tiers[tierIdx - 1]?.val || 0;

    // Toggle active state classes
    if (threshold > 0 && cartTotal >= threshold) {
      item.classList.add('is-active');
    } else {
      item.classList.remove('is-active');
    }

    if (layout === 'secondary') {
      const amountElem = item.querySelector('.tier-amount');
      if (amountElem && threshold > 0) {
        amountElem.innerText = `${marketSymbol}${Math.round(threshold / 100)}`;
      }

      const fillElem = item.querySelector('[data-progress-bar-segment]');
      if (fillElem && threshold > 0) {
        const prevThreshold = tierIdx === 1 ? 0 : config.tiers[tierIdx - 2].val;
        const segmentRange = threshold - prevThreshold;

        let segmentPercent = 0;
        if (cartTotal >= threshold) {
          segmentPercent = 100;
        } else if (cartTotal > prevThreshold) {
          segmentPercent = ((cartTotal - prevThreshold) / segmentRange) * 100;
        }

        /**
         * Animation Direction Logic:
         * If total is decreasing, remove delay for instant feedback.
         * If total is increasing, use sequential 0.3s delay.
         */
        fillElem.style.transitionDelay = isDecreasing ? '0s' : `${index * 0.3}s`;
        fillElem.style.width = `${segmentPercent}%`;
      }
    }
  });
};

window.syncMultibuyTiers = async function () {
  try {
    // 1. Fetch the latest cart state from Shopify
    const response = await fetch(window.Shopify.routes.root + 'cart.js');

    if (!response.ok) throw new Error('Could not fetch cart data');

    const cart = await response.json();

    const hasItems = cart.items.length > 0;
    const onlyGiftsRemaining = cart.items.every(item => {
      const attr = item.properties?._attribution;
      return typeof attr === 'string' && attr.toLowerCase().includes('gift');
    });


    if (hasItems && onlyGiftsRemaining) {
      document.querySelector('cart-drawer.cart-drawer').setAttribute('data-cart-items', '0');

      setTimeout(() => {
        window.getSectionHTML(true);
      }, 1000);
    }

    if (!hasItems) {
      document.querySelector('cart-drawer.cart-drawer').setAttribute('data-cart-items', '0');
    }

    // 2. Update the Multibuy Tiers UI
    // Ensure the window.updateMultibuyTiers function (from the previous step) is defined
    if (typeof window.updateMultibuyTiers === 'function' && document.querySelector('multibuy-tiers')) {
      window.updateMultibuyTiers(cart);
    } else {
      console.warn('window.updateMultibuyTiers is not defined.');
    }

  } catch (error) {
    console.error('Error syncing Multibuy Tiers:', error);
  }
};

window.syncMultibuyTiers();

window.rebuyCartUpsellWidgetHandler = function rebuyCartUpsellWidgetHandler() {
  const widgetId = '263949';

  if (typeof Rebuy === 'undefined' || !Rebuy.widgets) return;

  const widget = Rebuy.widgets.find(w => w.id === widgetId);
  if (!widget?.data?.products) return;

  const products = widget.data.products;

  setTimeout(() => {
    const productsDOM = document.querySelectorAll('.cart-drawer__upsell .rebuy-product-block');
    if (!productsDOM.length) return;

    const currencyRate = window.Shopify?.currency?.rate ? parseFloat(Shopify.currency.rate) : 1;
    const currencySymbol = window.marketCurrencySymbol || '$';

    productsDOM.forEach(productItem => {
      const productObject = products.find(p => productItem.classList.contains(p.handle));
      if (!productObject) return;

      const title = productItem.querySelector('.rebuy-product-title');
      if (!title) return;

      let descriptionElem = productItem.querySelector('.c-rebuy-product-description');
      if (!descriptionElem) {
        descriptionElem = document.createElement('div');
        descriptionElem.classList.add('c-rebuy-product-description');
        title.after(descriptionElem);
      }
      descriptionElem.innerText = productObject.description.replace(/\.$/, '');

      const originPrice = parseFloat(productObject.selected_variant.price);
      const compareAtPrice = parseFloat(productObject.selected_variant.compare_at_price);

      if (compareAtPrice && compareAtPrice > originPrice) {
        const rawDiff = (compareAtPrice - originPrice) * currencyRate;

        const formattedSave = rawDiff % 1 === 0
          ? rawDiff.toString()
          : Math.ceil(rawDiff).toString();

        let saveBadge = productItem.querySelector('.c-rebuy-product-save-badge');
        if (!saveBadge) {
          saveBadge = document.createElement('div');
          saveBadge.classList.add('c-rebuy-product-save-badge');
          title.appendChild(saveBadge);
        }

        saveBadge.innerText = `Save ${currencySymbol}${formattedSave}`;
      } else {
        productItem.querySelector('.c-rebuy-product-save-badge')?.remove();
      }
    });
  }, 150);
};

document.addEventListener('keydown', (event) => {
  const { target, key, keyCode } = event;

  if (keyCode === 13 || keyCode === 32) {
    const rebuyBtn = target.closest('.rebuy-button');

    if (rebuyBtn) {
      event.preventDefault(); // Prevent scrolling on Space
      rebuyBtn.click(); // Manually trigger the click for your async listener
      return; // Stop execution here so it doesn't hit the subscription logic
    }
  }

  // --- BLOCK 2: Subscription Plans Logic (Original Logic Restored) ---
  const currentPlan = target.closest('.subscribe__plan-item');

  if (!currentPlan) return;

  const footer = currentPlan.closest('.subscribe__modal-footer');
  if (!footer) return;

  const allPlans = Array.from(footer.querySelectorAll('.subscribe__plan-item'));
  const currentIndex = allPlans.indexOf(currentPlan);
  let nextIndex;

  if (key === 'ArrowDown' || key === 'ArrowRight') {
    event.preventDefault();
    nextIndex = (currentIndex + 1) % allPlans.length;
  } else if (key === 'ArrowUp' || key === 'ArrowLeft') {
    event.preventDefault();
    nextIndex = (currentIndex - 1 + allPlans.length) % allPlans.length;
  }
  else if (key === 'Enter' || key === ' ') {
    event.preventDefault();
    const radio = currentPlan.querySelector('.subscribe__plan-input');
    if (radio && !radio.checked) {
      radio.click();
    }
    return;
  }

  if (nextIndex !== undefined) {
    const nextPlan = allPlans[nextIndex];
    allPlans.forEach(plan => plan.setAttribute('tabindex', '-1'));
    nextPlan.setAttribute('tabindex', '0');
    nextPlan.focus();
  }
});

document.addEventListener('change', (event) => {
  if (!event.target.classList.contains('subscribe__plan-input')) return;

  const footer = event.target.closest('.subscribe__modal-footer');
  if (footer) {
    footer.querySelectorAll('.subscribe__plan-item').forEach(item => {
      const isChecked = item.querySelector('.subscribe__plan-input').checked;
      item.setAttribute('aria-checked', isChecked);
      item.setAttribute('tabindex', isChecked ? '0' : '-1');
    });
  }
});